/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { GetAdminMarketCreationStatusResponse, GetAdminMarketCreationStatusVars } from '../openapi-types.gen.js';

export type { GetAdminMarketCreationStatusResponse, GetAdminMarketCreationStatusVars } from '../openapi-types.gen.js';

export const useGetAdminMarketCreationStatus = createMutationHook<GetAdminMarketCreationStatusVars, GetAdminMarketCreationStatusResponse, unknown>({
  specName: 'useGetAdminMarketCreationStatus',
  path: '/v1/admin/market-creations/{id}/status',
  method: 'POST',
  resolveUrl: (vars: GetAdminMarketCreationStatusVars) => `/v1/admin/market-creations/${vars.id}/status`,
  buildBody: (vars: GetAdminMarketCreationStatusVars) => ({ proof: vars.proof, creatorProof: vars.creatorProof }),
  parseResponse: (raw: unknown): GetAdminMarketCreationStatusResponse => raw as GetAdminMarketCreationStatusResponse,
  
  
  
});
